import React from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import { FieldProps } from 'formik';

import { siteKey } from 'config/recaptcha';

const RecaptchaField: React.SFC<FieldProps> = ({
  field: { name, onChange, ...fieldProps },
  form: { setFieldValue },
  ...props
}) => {
  return (
    <ReCAPTCHA
      sitekey={siteKey}
      onChange={(token) => setFieldValue(name, token)}
      size="normal"
      {...fieldProps}
      {...props}
    />
  );
};

export default RecaptchaField;
